<div class="app-container" #appContainer>
  <app-credit-info-summary *ngIf="(showSumary$ | async) !== false" />
  <div class="py-4 px-4">
    <router-outlet></router-outlet>
  </div>
</div>

